import { createStore } from "solid-js/store"
import { DevicePreference, persisted } from "@/storage/persist"
import type { PathHelpers, ReviewDiffStyle, RightSidebarTab, SessionTabs, SessionView, TabHandoff } from "../layout-model"
import {
  DEFAULT_SESSION_WIDTH,
  DEFAULT_SIDEBAR_WIDTH,
  DEFAULT_TERMINAL_HEIGHT,
  DESKTOP_PANEL_WIDTH,
  normalizeSessionTab,
  normalizeSessionTabList,
} from "../layout-model"
import { createLayoutPreferenceMigration } from "./preferences"

export interface LayoutState {
  sidebar: { opened: boolean; width: number }
  terminal: { height: number }
  review: { diffStyle: ReviewDiffStyle }
  rightSidebar: { opened: boolean; widths: Partial<Record<RightSidebarTab, number>>; tab: RightSidebarTab }
  desktop: { width: number }
  stage: { width: number }
  session: { width: number }
  sessionTabs: Record<string, SessionTabs>
  sessionView: Record<string, SessionView>
  handoff: { tabs?: TabHandoff }
  projectOrder: string[]
}

export function createLayoutState(sessionPath: (key: string) => PathHelpers | undefined) {
  const normalizeStoredSessionTabs = (key: string, tabs: SessionTabs) => {
    const path = sessionPath(key)
    return {
      all: normalizeSessionTabList(path, tabs.all),
      active: tabs.active ? normalizeSessionTab(path, tabs.active) : tabs.active,
    }
  }
  return persisted(
    {
      ...DevicePreference.global("layout"),
      migrate: createLayoutPreferenceMigration(normalizeStoredSessionTabs),
      writeDelayMs: 150,
    },
    createStore<LayoutState>({
      sidebar: { opened: true, width: DEFAULT_SIDEBAR_WIDTH },
      terminal: { height: DEFAULT_TERMINAL_HEIGHT },
      review: { diffStyle: "split" },
      rightSidebar: { opened: true, widths: {}, tab: "explorer" },
      desktop: { width: DESKTOP_PANEL_WIDTH },
      stage: { width: 500 },
      session: { width: DEFAULT_SESSION_WIDTH },
      sessionTabs: {},
      sessionView: {},
      handoff: { tabs: undefined },
      projectOrder: [],
    }),
  )
}
